module.exports = __webpack_public_path__ + "img/z-qrcode1.b177bb2d.jpg";